export enum RestrictionTypeEnum {
	DIRECTOR = 'DIRECTOR',
	BANKING = 'BANKING',
}
